import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Modal } from "@/components/ui-bits";
import { Avatar } from "@/components/Avatar";

export const AssignModal = ({ exercise, onClose, onDone }) => {
  const [mode, setMode] = useState("clients");
  const [clients, setClients] = useState([]);
  const [groups, setGroups] = useState([]);
  const [picked, setPicked] = useState([]);
  const [pickedGroups, setPickedGroups] = useState([]);
  const [q, setQ] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { Promise.all([api.get("/clients"), api.get("/groups")]).then(([c, g]) => { setClients(c.data.filter((x) => x.active !== false)); setGroups(g.data); }); }, []);
  const toggle = (list, set, id) => set(list.includes(id) ? list.filter((x) => x !== id) : [...list, id]);
  const total = mode === "clients" ? picked.length : new Set(groups.filter((g) => pickedGroups.includes(g.id)).flatMap((g) => g.clientIds)).size;
  const submit = async () => {
    setBusy(true);
    try {
      const r = await api.post(`/exercises/${exercise.id}/assign`, mode === "clients" ? { clientIds: picked } : { groupIds: pickedGroups });
      toast.success(`${exercise.name} assigned to ${r.data.assigned} client${r.data.assigned !== 1 ? "s" : ""}${r.data.skipped ? ` (${r.data.skipped} already had it)` : ""}`);
      onDone();
    } catch (ex) { toast.error(errMsg(ex)); } finally { setBusy(false); }
  };
  const shown = clients.filter((c) => c.name.toLowerCase().includes(q.toLowerCase()));
  return (
    <Modal title={`ASSIGN · ${exercise.name.toUpperCase()}`} sub="Adds the exercise to each client's program — they see it in their portal library" onClose={onClose} testId="assign-modal">
      <div className="tabs" data-testid="assign-mode-tabs">
        <button type="button" className={mode === "clients" ? "on" : ""} onClick={() => setMode("clients")} data-testid="assign-mode-clients">Individual clients</button>
        <button type="button" className={mode === "groups" ? "on" : ""} onClick={() => setMode("groups")} data-testid="assign-mode-groups">Client group</button>
      </div>
      {mode === "clients" ? (
        <>
          <input placeholder="Search clients…" value={q} onChange={(e) => setQ(e.target.value)} data-testid="assign-search" />
          <div className="actions" style={{ margin: "8px 0" }}>
            <button type="button" className="btn sm g" onClick={() => setPicked(shown.map((c) => c.id))} data-testid="assign-select-all">Select all shown</button>
            <button type="button" className="btn sm g" onClick={() => setPicked([])} data-testid="assign-clear">Clear</button>
          </div>
          <div className="pick-list" data-testid="assign-client-list">
            {shown.map((c) => (
              <label className={`pick ${picked.includes(c.id) ? "on" : ""}`} key={c.id} data-testid={`assign-client-${c.id}`}>
                <input type="checkbox" checked={picked.includes(c.id)} onChange={() => toggle(picked, setPicked, c.id)} />
                <Avatar client={c} size={26} radius={7} /><span className="nm">{c.name}</span><span className="ss">{c.goal || ""}</span>
              </label>
            ))}
            {shown.length === 0 && <div className="ss">No clients match.</div>}
          </div>
        </>
      ) : (
        <div className="pick-list" data-testid="assign-group-list">
          {groups.length === 0 && <div className="ss" data-testid="assign-no-groups">No groups yet — create one under Clients → Groups (e.g. "Monday Morning Class").</div>}
          {groups.map((g) => (
            <label className={`pick ${pickedGroups.includes(g.id) ? "on" : ""}`} key={g.id} data-testid={`assign-group-${g.id}`}>
              <input type="checkbox" checked={pickedGroups.includes(g.id)} onChange={() => toggle(pickedGroups, setPickedGroups, g.id)} />
              <span className="nm">{g.name}</span><span className="ss">{g.members.length} member{g.members.length !== 1 ? "s" : ""} · {g.members.map((m) => m.name.split(" ")[0]).slice(0, 4).join(", ")}{g.members.length > 4 ? "…" : ""}</span>
            </label>
          ))}
        </div>
      )}
      <div className="mfoot">
        <button type="button" className="btn g" onClick={onClose} data-testid="assign-cancel">Cancel</button>
        <button type="button" className="btn" disabled={busy || total === 0} onClick={submit} data-testid="assign-confirm">{busy ? "Assigning…" : `Assign to ${total} client${total !== 1 ? "s" : ""}`}</button>
      </div>
    </Modal>
  );
};
